import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import { DeleteFlowDialog } from "../../DeleteFlowDialog";
import { updateFlow } from "api/FlowDesignerApis";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import { updatePortalFlow } from "redux/actions/portal/flowsActionCreator";
import { toast } from "react-toastify";
import { useFlowUsage } from "../../../../../hooks/useFlowUsage";

export const DeleteFlow = ({ handleFlowMenuClose, canDelete, item }) => {
   const { getUsage, invitedUsers, flowUsage } = useFlowUsage(item);
   const { user } = useAuth0();

   const [showDeleteFlowDialog, setShowDeleteFlowDialog] = useState(false);
   const dispatch = useDispatch();

   const handleDeletionOnDatabase = async () => {
      const { created_date_time, id, tenant_id, userAccessType, updated_date_time, ...restFlow } = item;

      try {
         const response = await updateFlow(user?.stripeId, item.id, { ...restFlow, trashed: true }, false);

         if (!response) {
            toast.error(`Unable to delete flow - ensure that an instance of the cxf-executor is running and that the Flow Designer is connected to it. Then, reload and try again.`, {
               autoClose: 5000,
               pauseOnHover: true
            });
            return;
         }

         dispatch(updatePortalFlow({ ...restFlow, trashed: true, id }));
         setShowDeleteFlowDialog(false);

         toast.success("Flow has been deleted successfully!");
      } catch {
         toast.error("Flow has not been deleted");
      }
   };

   const handleDelete = async () => {
      try {
         await getUsage();

         handleFlowMenuClose();
         setShowDeleteFlowDialog(true);
      } catch {
         toast.error("Failed to check flow usage");
      }
   };

   return (
      <>
         <MenuItem onClick={handleDelete} disabled={!canDelete}>
            Delete
         </MenuItem>
         <DeleteFlowDialog open={showDeleteFlowDialog} onAccept={handleDeletionOnDatabase} onClose={() => setShowDeleteFlowDialog(false)} flow={item} flowUsage={flowUsage} sharedUsers={invitedUsers} />
      </>
   );
};
